import { defineMessages } from 'react-intl';

export default defineMessages({
    wantToJump:{
        id:'quoteandbind.gen.wizard.step.Leave Page?',
        defaultMessage:"Leave Page?"
    },
    save: {
        id:'quoteandbind.gen.wizard.step.Save',
        defaultMessage:"Save"
    }
});
